// Cashfree's hosted checkout. The script is loaded only when someone pays online; the payment session comes from the
// pay Edge Function, and the result is checked on the server when Cashfree sends the person back (never trusted here).
const SDK_URL = 'https://sdk.cashfree.com/js/v3/cashfree.js';

type CashfreeInstance = {
  checkout: (o: { paymentSessionId: string; redirectTarget?: '_self' | '_blank' | '_top' | '_modal' }) => Promise<unknown>;
};
declare global {
  interface Window { Cashfree?: (o: { mode: 'sandbox' | 'production' }) => CashfreeInstance }
}

let loading: Promise<void> | null = null;

function loadSdk(): Promise<void> {
  if (window.Cashfree) return Promise.resolve();
  loading ??= new Promise<void>((resolve, reject) => {
    const s = document.createElement('script');
    s.src = SDK_URL;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => { loading = null; reject(new Error('gateway_unreachable')); };
    document.head.appendChild(s);
  });
  return loading;
}

/** Opens Cashfree's checkout in this tab; Cashfree returns the person to the order page afterwards. */
export async function openCheckout(sessionId: string, mode: 'sandbox' | 'production'): Promise<void> {
  await loadSdk();
  if (!window.Cashfree) throw new Error('gateway_unreachable');
  await window.Cashfree({ mode }).checkout({ paymentSessionId: sessionId, redirectTarget: '_self' });
}
